import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { endingLeasesQueryKey } from '@services/dashboard/queries/useEndingLeases'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

/** Send a missed end-of-lease reminder to the main tenant now. */
export function useSendLeaseReminder() {
  const queryClient = useQueryClient()
  const toast = useToast()
  const { t } = useTranslation('toast')
  const onError = useOnError()

  async function sendReminder(contractId: string) {
    const res = await apiClient.post(
      `${SNA_PREFIX}dashboard/ending-leases/${contractId}/send-reminder`
    )
    return res.data
  }

  return useMutation({
    mutationFn: sendReminder,
    onSuccess: () => {
      toast.success({ message: t('leaseReminderSent') })
      queryClient.invalidateQueries({ queryKey: endingLeasesQueryKey })
    },
    onError
  })
}
